var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5719_20163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 5.51857C12.75 5.86534 12.6256 6.16334 12.3768 6.41257C12.1281 6.66181 11.8306 6.78642 11.4845 6.78642C11.1384 6.78642 10.841 6.66181 10.5922 6.41257C10.3434 6.16334 10.219 5.86534 10.219 5.51857C10.219 5.1664 10.3434 4.8684 10.5922 4.62458C10.841 4.37535 11.1384 4.25073 11.4845 4.25073C11.8306 4.25073 12.1281 4.37535 12.3768 4.62458C12.6256 4.8684 12.75 5.1664 12.75 5.51857ZM11.3872 13.532H12.2065C11.5143 15.0112 10.5462 15.7507 9.30236 15.7507C8.7994 15.7507 8.42084 15.6451 8.16667 15.4338C7.91249 15.2225 7.7854 14.9083 7.7854 14.491C7.7854 14.2472 7.89085 13.8192 8.10177 13.2069L9.07522 10.403C9.15093 10.1863 9.18879 10.0454 9.18879 9.98042C9.18879 9.91541 9.17256 9.86935 9.14011 9.84226C9.11308 9.80975 9.06711 9.79349 9.00221 9.79349C8.7264 9.79349 8.40191 10.1457 8.02876 10.85H7.25C7.94764 9.33837 8.9319 8.58254 10.2028 8.58254C10.6517 8.58254 11.0005 8.69361 11.2493 8.91576C11.498 9.13249 11.6224 9.43319 11.6224 9.81788C11.6224 10.0996 11.5115 10.5466 11.2898 11.1589L10.3488 13.7271C10.2136 14.0901 10.146 14.3177 10.146 14.4098C10.146 14.4693 10.1622 14.5154 10.1947 14.5479C10.2325 14.5804 10.2839 14.5966 10.3488 14.5966C10.4894 14.5966 10.6679 14.4747 10.8842 14.231C11.1059 13.9871 11.2736 13.7542 11.3872 13.532Z",
    fill: "#BDC0C7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.0005,
    r: 9.5,
    stroke: "#BDC0C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5719_20163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.03aa9bbd2dce8b09321527a19ccd6696.svg";
export { ForwardRef as ReactComponent };